import React, { useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * ForgotPassword — user enters their email to receive a password reset link.
 * (In dev mode the reset link is logged to the server console.)
 */
function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.error || "Noe gikk galt");
        setLoading(false);
        return;
      }

      setSent(true);
      toast.success("📧 Sjekk e-posten din!");
    } catch (err) {
      toast.error("Kan ikke koble til serveren.");
    }
    setLoading(false);
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="card shadow" style={{ width: "420px" }}>
        <div className="card-body p-4">
          <h3 className="card-title text-center mb-3">🔑 Glemt passord</h3>

          {sent ? (
            <div className="text-center">
              <div className="alert alert-success">
                <strong>✅ Sjekk e-posten din!</strong><br />
                Vi har sendt en lenke for å tilbakestille passordet ditt til <strong>{email}</strong>.
              </div>
              <Link to="/login" className="btn btn-outline-primary mt-2">
                ← Tilbake til innlogging
              </Link>
            </div>
          ) : (
            <>
              <p className="text-muted text-center mb-4">
                Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.
              </p>
              <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                  <label htmlFor="forgot-email" className="form-label">E-postadresse</label>
                  <input
                    id="forgot-email"
                    type="email"
                    className="form-control"
                    placeholder="din@epost.no"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100 mb-3" disabled={loading}>
                  {loading ? "Sender..." : "📧 Send tilbakestillingslenke"}
                </button>
              </form>
              <p className="text-center text-muted mb-0">
                <Link to="/login" className="text-decoration-none">← Tilbake til innlogging</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
